import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { editOrg } from './formData';
import { homePageAction, superAdminAction } from '../../../../_actions';
import './index.css';

class OrgDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            orgId: null,
            editOrgModal: false,
            deleteOrgModal: false,
            updateModalState: false,
            deleteResponseMessage: false,
            updateMessage: null,
            orgDetails: null,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(this.props.headPerLoadingResonse.data.is_pa_user == true) {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(this.props.headPerLoadingResonse.data.is_org_admin == true) {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(this.props.headPerLoadingResonse.data. is_super_admin == true) {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        this.props.dispatch(homePageAction.getCountryListHandler());
        this.setState({ orgId: id })
        this.props.dispatch(superAdminAction.getOrgDetailsHandler(id, (getOrgDetails) => {
            this.setState({ orgDetails: getOrgDetails.data.organisation[0] })
        }))

    }

    toggleEditOrgModal(showModal) {
        this.setState({
            editOrgModal: showModal,
        })
    }

    toggleDeleteOrgModal(showModal) {
        this.setState({
            deleteOrgModal: showModal,
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    toggleEntireOrgModal(showModal) {
        this.setState({
            deleteOrgModal: showModal,
            editOrgModal: showModal,
        })
    }

    actionSelected(data) {
        const fd = {
            'organisation_name': data.data.organisation_name,
            "country": data.data.country__id
        }
        this.props.dispatch(superAdminAction.editOrgDetailsHandler(this.state.orgId, fd, (responseData) => {
            this.setState({
                updateModalState: true,
                updateMessage: {
                    text: `<div className = " text-center">
                    <p className = "font-weight-bold">Success!</p>
                    <p>${this.state.orgDetails.organisation_name} details Updated successfully.</p>
                </div>`,
                    heading: 'Edit Organisation',
                    headerColor: responseData.status === 200 ? `` : `bg-danger`,
                    headingIcon: 'fa fa-check text-white'
                },
            })
        }))
    }

    onClickDeleteOrg = (type) => {
        const { orgId } = this.state;
        if (type === 'Cancel') {
            this.setState({
                deleteOrgModal: false
            })
        }

        if (type === 'Remove') {
            const fd = {
                "organisation_id": orgId
            }
            this.props.dispatch(superAdminAction.deleteOrgDetailsHandler(fd, (data) => {
                this.setState({
                    deleteOrgModal: false,
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${data.status === 200 ? 'Success!' : 'Error!'}</p>
                        <p>${this.state.orgDetails.organisation_name}: ${data.data.message}.</p>
                    </div>`,
                        heading: 'Delete Organisation',
                        headerColor: data.status === 200 ? `` : `bg-danger`,
                        headingIcon: data.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
            }))
        }
    }

    render() {
        const { getCountryListResponse, getOrgDetailsResponse } = this.props;
        editOrg.map(function (element) {
            if (element.key === 'country__id') {
                element.elementConfig.options = getCountryListResponse;
            }
        });
        this.state.deleteResponseMessage === true &&
            this.props.history.push('/')

        const tables = {
            Team: [{
                name: 'Organisation Name',
                key: 'organisation_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: true,
                headingAlign: true,
                link: ''
            },
            {
                name: 'Country',
                key: 'country__country_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: true,
                headingAlign: true,
                link: ''
            },
            ]
        }

        this.state.editOrgModal === true &&
            editOrg.map(
                (data, i) => {
                    data.value = getOrgDetailsResponse[0][data.key]
                    data.valid = true;
                }
            )
        return (
            <div>
                <Navbar key={this.props.headPerLoadingResonse} navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">ORGANISATION DETAILS</h5>
                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Edit ',
                                    toggler: this.toggleEditOrgModal.bind(this),
                                    togglerModal: this.state.editOrgModal,
                                    icon: 'fa fa-edit',
                                    title: 'Edit'
                                }, {
                                    id: 2,
                                    name: 'Delete ',
                                    toggler: this.toggleDeleteOrgModal.bind(this),
                                    togglerModal: this.state.deleteOrgModal,
                                    icon: 'fa fa-minus',
                                    title: 'Delete'
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            getOrgDetailsResponse !== '' &&
                            <TableNew
                                data={getOrgDetailsResponse}
                                columns={tables.Team}
                            />
                        }
                        {
                            (getOrgDetailsResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }


                        {
                            this.state.editOrgModal &&
                            <ModalComponent
                                showModal={this.state.editOrgModal}
                                heading="Edit Team"
                                formData={editOrg}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                footerFormSubmitButton={['Save', 'Cancel']}
                                selectKey={['id']}
                                selects={['country_name']}
                            />
                        }

                        {
                            this.state.deleteOrgModal &&
                            <ModalComponent
                                showModal={this.state.deleteOrgModal}
                                heading="Delete Organisation"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 text-center">
                                <p>Are you sure you want to Delete the Org below?</p>
                                <span>Organisation Name:</span><span className = 'font-weight-bold'>&nbsp;${this.state.orgDetails.organisation_name}</span>
                                </div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickDeleteOrg(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false, deleteResponseMessage: this.state.updateMessage.heading === 'Delete Organisation' && this.state.updateMessage.status === 200 ? true : false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false, deleteResponseMessage: this.state.updateMessage.heading === 'Delete Organisation' && this.state.updateMessage.status === 200 ? true : false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getCountryListLoading } = state.getCountryListReducer;
    const getCountryListError = state.getCountryListReducer.error;
    const getCountryListResponse = (!getCountryListLoading && !getCountryListError) ? state.getCountryListReducer.data.data.country_list : '';

    const { getOrgDetailsLoading } = state.getOrgDetailsReducer;
    const getOrgDetailsError = state.getOrgDetailsReducer.error;
    const getOrgDetailsResponse = (!getOrgDetailsLoading && !getOrgDetailsError) ? state.getOrgDetailsReducer.data.data.organisation : '';

     //Header Permission
     const { headPerLoading } = state.headerPermissionReducer
     const headPerLoadingError = state.headerPermissionReducer.error
     const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getCountryListLoading,
        getCountryListResponse,

        getOrgDetailsLoading,
        getOrgDetailsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    };
}

export default connect(mapStateToProps)(OrgDetails);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/OrgDetails/index.js